import React, { useState } from 'react';

import { Notification } from '@rio-cloud/rio-uikit';

import { InputDate } from '@components';
import moment from 'moment';
import { FormAgendamentoProps } from '../types';
import { getInputStyle } from '../utils/formUtils';

const FormAgendamento: React.FC<FormAgendamentoProps> = ({
  formData,
  errors,
  onDateChange,
  onHourChange,
  onHourValidation
}) => {

  const [hasNotification, setHasNotification] = useState(false);

  const showNotification = (message: string) => {
    if (!hasNotification) {
      setHasNotification(true);
      Notification.error(message);
      setTimeout(() => setHasNotification(false), 3000);
    }
  };

  const handleHourBlur = () => {
    if (!formData.hour) return;

    const isValidFormat = /^\d{2}:\d{2}$/.test(formData.hour);

    if (!isValidFormat) {
      showNotification("Formato de hora inválido. Use HH:MM (00:00 a 23:59) para agendar a viagem");
    } else if (onHourValidation) {
      onHourValidation(formData.hour);
    } else {
      onHourChange(formData.hour);
    }
  }; 

  return (
    <div className="margin-top-50 display-flex gap-15 flex-column">
      <span className="text-bold text-size-16">Informe a data e hora da viagem:</span>

      <div className="margin-top-10">
        <div>
          <InputDate
            label="Data"
            inputProps={{
              placeholder: "Selecione o dia.",
              id: "date-input",
              autoComplete: "off",
              style: getInputStyle(!!errors.date),
            }}
            dateFormat="DD/MM/YYYY"
            timeFormat={false}
            value={formData?.date ? moment(formData.date).format("DD/MM/YYYY") : ''}
            onChange={(date) => onDateChange(moment(date).format('YYYY-MM-DD'))}
          />
        </div>

        <div className="margin-bottom-20 margin-top-20">
          <div className="margin-bottom-4">
            <span className="text-size-14 text-normal text-color-dark line-height-16">Hora</span>
          </div>

          <div className="input-group">
            <span className="input-group-addon">
              <span className="rioglyph rioglyph-calendar" />
            </span>
            <input
              type="text"
              className="form-control"
              style={getInputStyle(!!errors.hour || !!errors.date)}
              placeholder="Selecione o horário."
              id="hour-input"
              autoComplete="off"
              value={formData.hour}
              onChange={(e) => onHourChange(e.target.value)}
              onBlur={handleHourBlur}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormAgendamento; 